import "@/styles/site.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/admin/ProtectedRoute";

import Home from "@/pages/Home";
import Deci from "@/pages/Deci";
import TactileHealth from "@/pages/TactileHealth";
import News from "@/pages/News";
import NewsDetail from "@/pages/NewsDetail";
import InvestorRelations from "@/pages/InvestorRelations";
import Contact from "@/pages/Contact";
import RecoveryExplorer from "@/pages/RecoveryExplorer";
import Login from "@/admin/Login";
import Dashboard from "@/admin/Dashboard";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/deci" element={<Deci />} />
          <Route path="/tactile-health" element={<TactileHealth />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:id" element={<NewsDetail />} />
          <Route path="/investor-relations" element={<InvestorRelations />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/recovery" element={<RecoveryExplorer />} />
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
